export default {
  mounted() {
    this.el.addEventListener("click", () => {
      const text = this.el.dataset.clipboard || this.el.dataset.value || ""
      navigator.clipboard.writeText(text).then(() => {
        const icon = this.el.querySelector(".copy-icon")
        const check = this.el.querySelector(".check-icon")
        if (icon) icon.classList.add("hidden")
        if (check) check.classList.remove("hidden")
        setTimeout(() => {
          if (icon) icon.classList.remove("hidden")
          if (check) check.classList.add("hidden")
        }, 1500)
      })
    })
  }
}
